import React from 'react';
import {
  Container, Col, Row,
} from '../../components/grid';
import {
  Heading1,
  Paragraph,
  Heading2,
  LinkStyled,
} from '../../components/typography';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import TheVideoPlayer from '../../components/TheVideoPlayer';

export default () => (
  <SidemenuLayout menuPicker="Anlaeg" activeSidemenu="SaadanTapperPerfektFadoel">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>Sådan tapper du den perfekte fadøl</Heading1>
          <Paragraph>
            HAt tappe den perfekte fadøl er en kunst! Her på siden finder du en guide til hvordan du får det bedste resultat i glasset. Nyd smagen, skummet og den flotte gyldne farve - hver eneste gang.
            Husk, at du også kan leje et <LinkStyled to="/fadoelsanlaeg">fadølsanlæg</LinkStyled> hos Skafte, så du er klar til din næste fest eller arrangement.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container mb>
      <Row>
        <Col xs={12} padding="0">
          <TheVideoPlayer
            url="fbAsc4Z5AfI?t=434"
            thumbnail="saadan-tappes-perfekt"
            chapters={[
            {
              time: '00:00',
              description: '00:00 - Opstilling af udstyr og tilslutning af strøm',
            },
            {
              time: '01:19',
              description: '01:19 - Tilslutning af fadøl og kulsyre til fadølsanlæg',
            },
            {
              time: '03:11',
              description: '03:11 - Sådan virker vandkølede fadølsanlæg',
            },
            {
              time: '06:06',
              description: '06:06 - Opsætning af fadølsbar og tappetårn',
            },
            {
              time: '07:13',
              description: '07:13 - Forberedelse før tapning af fadøl',
            },
            {
              time: '08:36',
              description: '08:36 - Sådan tapper du en perfekt fadøl',
            },
          ]}
          />
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0px">
          <Heading2>Forberedelse før tapning på anlægget</Heading2>
        </Col>
        <Col xs={12} doubleColumn paddingTop="0px">
          <Paragraph>
            Efter rensning er fadølsanlægget skyllet med almindeligt vand. Dette vand skal tappes ud inden brug. Tapper man ikke vandet ud inden køleren tændes, er der risiko for, at vandet fryser til is og blokerer for øllet.
            Tap vand ud indtil der kommer øl i glasset i stedet. Det er ca. et halvt glas. Afhængig af årstiden og øllets temperatur, kan anlægget først testes efter ca. en halv time, mens fuld kapacitet opnås efter 2-4 timer.
          </Paragraph>
          <Paragraph>
            Når man ikke skal bruge anlægget i en længere periode, så er det klogt, at lukke for kulsyreflasken, så anlægget ikke står med tryk på. Når du skal lukke for kulsyren, skal du dreje ca. to omgange. Løft håndtaget op, så der er lukket af for øllet og tag ikke koblingen af. Når man skal bruge anlægget igen, så åbner man helt for kulsyren og trykker derefter håndtaget på fadølskoblingen ned.
          </Paragraph>
          <Paragraph>
            Har man haft lukket for øllet og åbner igen, vil der komme en lille smule luft i ølslangen. Luften skal hele vejen igennem systemet og det tager ca. 2-3 glas. Så kommer der en lille smule sprutteri og så er anlægget klar igen.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12} paddingBottom="0px">
          <Heading2>Sådan tapper du den perfekte fadøl</Heading2>
        </Col>
        <Col xs={12} doubleColumn paddingTop="0px">
          <Paragraph>
            Nu til den bedste del: hvordan du skænker en iskold fadøl fra tappen.
            Hold glasset skrå og vip håndtaget helt ned i ét snuptag. Ret glasset op efterhånden som det fyldes. Ved at gøre sådan, ses det tydeligt, at øllet løber helt klart ud af hanen. Det er vigtigt, at man ikke vipper forsigtigt udad eller indad i håndtaget, men i stedet helt ned og vandret, i ét hug. Hvis man gør det forsigtigt, kommer der tykt skum ud og er der først skum i glasset, bliver det kun ved med at skumme.
          </Paragraph>
          <Paragraph>
            Under festen, og specielt når folk selv tager, er det vigtigt, at holde øje med at gæsterne vipper håndtaget helt ned i ét snuptag.
            Hvis det er meget varmt skal man især være opmærksom på, at øllet i slangen fra køleren til hanen kan blive varmt. Hvis man ikke bruger anlægget i en periode på bare 10-15 minutter, så kan øllet i slangen mellem anlæg og hane blive varmt. Det smager ikke særlig godt og det skummer alt for meget.
          </Paragraph>
          <Paragraph>
            Hvis anlægget ikke har været brugt i en periode, kan man ikke undgå, at der kommer lidt skum ud. Det fylder ikke mere end et enkelt glas, og når øllet løber klart, så er anlægget klar til brug igen.
          </Paragraph>
          <Paragraph>
            Så er det bare at nyde festen, din fadølsanlæg leje og ikke mindst øllet.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
